import zh from './zh';
import en from './en';
import zhTW from './zh-TW';
import ja from './ja';
import ko from './ko';
import es from './es';
import fr from './fr';
import de from './de';
import pt from './pt';
import ru from './ru';
import vi from './vi';
import th from './th';
import id from './id';

export const messages = { zh, en, 'zh-TW': zhTW, ja, ko, es, fr, de, pt, ru, vi, th, id };
